import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2Icon } from 'lucide-react';
const benefits = ['Más claridad para empezar tu camino', 'Más independencia financiera', 'Más confianza para ofrecer servicios', 'Una opción simple y actual', 'Una ruta práctica desde tu celular'];
export function BenefitsSection() {
  return <section className="bg-navy text-white py-16 md:py-24 relative overflow-hidden" data-id="element-10">
      {/* Decorative background element */}
      <div className="absolute -right-40 -top-40 w-96 h-96 bg-gold/10 rounded-full blur-[100px] pointer-events-none" data-id="element-11" />

      <div className="max-w-4xl mx-auto px-4 relative z-10" data-id="element-12">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-12" data-id="element-13">
          <h2 className="text-3xl md:text-4xl font-bold mb-4" data-id="element-14">
            Lo que vas a lograr
          </h2>
          <div className="w-24 h-1 bg-gold mx-auto rounded-full" data-id="element-15" />
        </motion.div>

        <div className="bg-navy-dark/50 border border-white/10 rounded-3xl p-8 md:p-12 backdrop-blur-sm" data-id="element-16">
          <ul className="space-y-6" data-id="element-17">
            {benefits.map((benefit, index) => <motion.li key={index} initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.15
          }} className="flex items-center gap-4 text-lg md:text-xl" data-id="element-18">
                <CheckCircle2Icon className="w-8 h-8 text-gold shrink-0" data-id="element-19" />
                <span className="text-gray-200" data-id="element-20">{benefit}</span>
              </motion.li>)}
          </ul>
        </div>
      </div>
    </section>;
}